// cnpm i spark-md5 -S
import SparkMD5 from 'spark-md5'

function md5 (file, fn) {
  let reader = new FileReader()
  reader.readAsBinaryString(file)
  reader.onload = e => {
    let imgFlag = e.target.result
    let spark = new SparkMD5()
    spark.appendBinary(imgFlag)
    let str = spark.end()
    fn && fn(str)
  }
}

export const md52 = (str, fn) => {
  let spark = new SparkMD5()
  spark.append(str)
  let aa = spark.end()
  return aa
}

export {md5}



// WEBPACK FOOTER //
// ./src/tools/md5.js